import axios from "axios";
import errorInterceptor from "./axios-401-response-interceptor";
import updateHeaderInterceptor from "./Request-Header-Interceptor";
const httpClient = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
});
errorInterceptor(httpClient);
updateHeaderInterceptor(httpClient);
export default httpClient;